import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-90737bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml20 p20"
};
const _hoisted_2 = {
  class: "mr100"
};
const _hoisted_3 = {
  class: "mr100"
};
const _hoisted_4 = {
  class: "mr10"
};
const _hoisted_5 = {
  class: "flex_FSBC mb10"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_blue"
}, "运单总金额：", -1));
const _hoisted_7 = {
  class: "text_red"
};
const _hoisted_8 = {
  class: "text_blue ml100"
};
const _hoisted_9 = {
  class: "text_red"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    class: "flex flex_FS"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
      label: "日期ᅟᅠ"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $setup.data.year,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.year = $event),
        placeholder: "请选择年份",
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.years, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        class: "ml10",
        modelValue: $setup.data.month,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.data.month = $event),
        placeholder: "请选择月份",
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.months, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item,
            value: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "托运方"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.draweeName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.draweeName = $event),
        placeholder: "请输入托运方"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
      label: "运单状态"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $setup.data.status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.data.status = $event),
        placeholder: "请选择运单状态",
        onChange: $setup.statementQuery
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          value: -1,
          label: "全部"
        }, {
          default: _withCtx(() => [_createTextVNode("全部")]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderStatusList, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item,
            value: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "承运方ᅟᅠ"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.drawerName,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.data.drawerName = $event),
        placeholder: "请输入承运方"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form_item, {
      label: "开票状态"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $setup.data.invoiceSuccess,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.data.invoiceSuccess = $event),
        placeholder: "请选择开票状态",
        onChange: $setup.statementQuery
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          value: -1,
          label: "全部"
        }, {
          default: _withCtx(() => [_createTextVNode("全部")]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invoiceSuccessList, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item,
            value: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "货物ᅟᅠᅟᅠ"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.goodsName,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.data.goodsName = $event),
        placeholder: "请输入货物"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $setup.statementQuery
      }, {
        default: _withCtx(() => [_createTextVNode("查询")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: $setup.reset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(($setup.data?.amount / 100 || 0).toFixed(2)) + "元", 1), _createElementVNode("span", _hoisted_8, [_createTextVNode("开票总金额： "), _createElementVNode("span", _hoisted_9, _toDisplayString(($setup.data?.invoiceAmount / 100 || 0).toFixed(2)) + "元", 1)])]), _createVNode(_component_el_button, {
    class: "ml20",
    disabled: !$setup.data.list.length,
    type: "primary",
    onClick: $setup.exportForwarderStatement
  }, {
    default: _withCtx(() => [_createTextVNode("导出")]),
    _: 1
  }, 8, ["disabled", "onClick"])]), _createVNode(_component_el_table, {
    data: $setup.data.list,
    border: "",
    "show-overflow-tooltip": "true"
  }, {
    empty: _withCtx(() => [_createVNode(_component_el_empty, {
      description: "暂无数据"
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "orderNo",
      fixed: "left",
      label: "运单号",
      width: "200"
    }), _createVNode(_component_el_table_column, {
      label: "托运方",
      prop: "forwarderEnterpriseName",
      width: "260"
    }), _createVNode(_component_el_table_column, {
      label: "承运方",
      prop: "drawerName",
      width: "200"
    }), _createVNode(_component_el_table_column, {
      label: "运输货物",
      prop: "goodsName",
      width: "160"
    }), _createVNode(_component_el_table_column, {
      label: "运单金额（元）",
      width: "160"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.amount / 100), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "开票金额（元）",
      width: "160"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.invoiceAmount / 100), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "运单状态",
      width: "200"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString($setup.orderStatusList[scope.row.orderStatus]), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "开票状态",
      width: "200"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString($setup.invoiceSuccessList[scope.row.invoiceSuccess]), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "建单日期",
      width: "150"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString($setup.moment(scope.row.createTime).format("YYYY-MM-DD")), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "操作",
      fixed: "right",
      width: "150"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        type: "primary",
        text: "",
        onClick: () => $setup.viewDetail(scope.row.orderId)
      }, {
        default: _withCtx(() => [_createTextVNode("查看详情")]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      "page-size": $setup.data.size,
      class: "mt20",
      background: "",
      layout: "pager,total",
      total: $setup.data.total,
      onCurrentChange: $setup.currentChange
    }, null, 8, ["page-size", "total", "onCurrentChange"])]),
    _: 1
  }, 8, ["locale"])]);
}